<template>
    <template v-for="(purpose, index) in purposeArr" :key="index">
        <span class="badge" :class="badgeClass(purpose)">{{ purpose }}</span>
    </template>
  
</template>

<script>
export default {
    props: ["purpose"],
    


    setup(props) {
        let purposeArr = props.purpose.split(",");;

        return {
            purposeArr
        }
    },

    methods: {
        badgeClass(purpose) {
            if(purpose == '政') return 'badge-p'
            if(purpose == '建') return 'badge-s'
            if(purpose == '整') return 'badge-i'
            if(purpose == '實') return 'badge-e'
        }
    },


}
</script>

<style>
.badge {
  background-color: #6c757d;
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  margin: 0px 8px;
}

.badge-p {
  background-color: var(--blue);
}

.badge-s {
  background-color: var(--red);
}

.badge-i {
  background-color: var(--green);
}

.badge-e {
  background-color: var(--purple);
}

</style>
